import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import SEO from "@/components/SEO";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="login-page">
      <SEO title="Agent & admin sign-in" description="Point Penta staff portal." path="/login" noIndex />
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-6 w-full">
        <Link to="/" className="flex items-center gap-3" data-testid="login-logo">
          <img
            src="https://customer-assets.emergentagent.com/job_penta-realty-uae/artifacts/lk46xfkn_Point%20Penta%20Logo%20png.png"
            alt="Point Penta"
            className="h-11 w-auto"
          />
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-16">
        <form onSubmit={submit} className="w-full max-w-md border border-[#e5e7eb] p-10 bg-white" data-testid="login-form">
          <div className="overline text-[#001588] mb-3">Agent & admin portal</div>
          <h1 className="font-serif text-4xl mb-8 text-[#050d19]">Sign in.</h1>
          <label className="block mb-4">
            <span className="overline text-neutral-500 block mb-2">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white border border-[#e5e7eb] px-4 py-3 focus:outline-none focus:border-[#001588]"
              data-testid="login-email" />
          </label>
          <label className="block mb-6">
            <span className="overline text-neutral-500 block mb-2">Password</span>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white border border-[#e5e7eb] px-4 py-3 focus:outline-none focus:border-[#001588]"
              data-testid="login-password" />
          </label>
          <button type="submit" disabled={busy}
            className="w-full py-3 bg-[#001588] text-white tracking-wide hover:bg-black transition-colors disabled:opacity-50"
            data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <div className="flex items-center justify-between mt-4">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs uppercase tracking-[0.18em] text-[#001588] hover:underline">
              Forgot your ID or password?
            </Link>
            <Link to="/" className="text-xs uppercase tracking-[0.18em] text-neutral-500 hover:text-[#001588]">
              Back to site
            </Link>
          </div>
          <div className="text-xs text-neutral-500 mt-6 leading-relaxed">
            Staff access only. Public users can browse properties without an account.
          </div>
        </form>
      </div>
    </div>
  );
}
